

import state from './moduleAutoInvoicesState.js'
import mutations from './moduleAutoInvoicesMutations.js'
import actions from './moduleAutoInvoicesActions.js'
import getters from './moduleAutoInvoicesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

